'use strict';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRevision } from '../../../../core/interfaces/workflow.interface';
import { IHistoryColumnData } from '../../../interfaces/history.interface';

@Component({
  selector: 'gen-history-table',
  templateUrl: './history-table.component.html',
  styleUrls: ['./history-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryTableComponent implements OnInit {
  @Output() historyRowClick: EventEmitter<any> = new EventEmitter();
  @Input() columnsToDisplay: Array<IHistoryColumnData> = [];
  @Input() currentRevisionId: string;
  @Input() maxNumberOfDisplayedRows: number = 10;
  public rowsToDisplay: Array<{ revision: IRevision, item: { [prop: string]: any}}>;
  private _historyData: Array<{ revision: IRevision, item: { [prop: string]: any}}> = [];

  @Input() set historyData(data: Array<{ revision: IRevision, item: { [prop: string]: any}}>) {
    if (data) {
      this._historyData = data;
      this.rowsToDisplay = this._historyData.slice(0, this.maxNumberOfDisplayedRows);
    }
  }

  get historyData() {
    return this._historyData;
  }

  constructor() { }

  ngOnInit() { }

  rowClick(historyItem) {
    const revisionId = historyItem.revision.id;
    if (revisionId != this.currentRevisionId) {
      this.historyRowClick.emit(historyItem);
    }
  }

  loadNext(event) {
    this.rowsToDisplay = this.historyData.slice(event.first, event.first + event.rows);
  }

  getRowClasses(revisionData) {
    const self = this;
    const currentRow = 'current Auto_History_List_Item';
    const defaultRow = 'Auto_History_List_Item';
    return revisionData.revision.id == self.currentRevisionId ? currentRow : defaultRow;
  }
}
